var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9L2 4V14H12V16H2C1.45 16 0.979333 15.8043 0.588 15.413C0.196 15.021 0 14.55 0 14V2C0 1.45 0.196 0.979 0.588 0.587C0.979333 0.195667 1.45 0 2 0H18C18.55 0 19.021 0.195667 19.413 0.587C19.8043 0.979 20 1.45 20 2V7H18V4L10 9ZM10 7L18 2H2L10 7ZM18 20C16.9 20 15.9583 19.6083 15.175 18.825C14.3917 18.0417 14 17.1 14 16V11.5C14 10.8 14.2417 10.2083 14.725 9.725C15.2083 9.24167 15.8 9 16.5 9C17.2 9 17.7917 9.24167 18.275 9.725C18.7583 10.2083 19 10.8 19 11.5V16H17V11.5C17 11.3667 16.95 11.25 16.85 11.15C16.75 11.05 16.6333 11 16.5 11C16.3667 11 16.25 11.05 16.15 11.15C16.05 11.25 16 11.3667 16 11.5V16C16 16.55 16.1957 17.021 16.587 17.413C16.979 17.8043 17.45 18 18 18C18.55 18 19.021 17.8043 19.413 17.413C19.8043 17.021 20 16.55 20 16V12H22V16C22 17.1 21.6083 18.0417 20.825 18.825C20.0417 19.6083 19.1 20 18 20ZM2 4V2V14V4Z",
    fill: "#42426E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachEmail);
export default __webpack_public_path__ + "static/media/attach_email.c56d8a0af91feb96a77a663ffe543885.svg";
export { ForwardRef as ReactComponent };